/**
 * 环境标识
 */
export var AppEnv;
(function (AppEnv) {
    /**
     * 测试
     */
    AppEnv["Test"] = "test";
    /**
     * 灰度
     */
    AppEnv["Gray"] = "gray";
    /**
     * 正式
     */
    AppEnv["Prod"] = "prod";
})(AppEnv || (AppEnv = {}));
/**
 * 是否是正式环境
 * @param env
 * @returns
 */
export const isEnvProd = (env) => {
    return env === AppEnv.Prod;
};
/**
 * 异常事件
 */
export const EVENT_EXCEPTION = 'exception';
export const EVENT_PAGE_VIEW = 'page_view';
/**
 * 埋点渠道
 */
export var AnalyticsChannel;
(function (AnalyticsChannel) {
    AnalyticsChannel["Disable"] = "";
    AnalyticsChannel["GTM"] = "gtm";
    AnalyticsChannel["Firebase"] = "firebase";
})(AnalyticsChannel || (AnalyticsChannel = {}));
